<template>
  <div class="d-flex">
    <b-badge ref="badge__lu-status" pill :variant="statusVariant" :class="statusClass">
      <span>{{ learningUnit.status }}</span>
    </b-badge>

    <b-badge
      v-if="learningUnit.latest_request_changes_at && !learningUnit.is_published"
      ref="badge__requested-changes"
      pill
      variant="neutral-danger"
      class="badge__lu-requested-changes-status text-danger ml-2"
    >
      <span>Requested changes</span>
    </b-badge>
  </div>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';

export default {
  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    }
  },

  computed: {
    statusVariant() {
      let variant = 'danger-dark';

      if (this.learningUnit.required_review) {
        variant = 'neutral-warning';
      }

      if (this.learningUnit.is_published) {
        variant = 'neutral-success';
      }

      return variant;
    },

    statusClass() {
      return {
        'badge__lu-draft-status text-dark':
          !this.learningUnit.required_review && !this.learningUnit.is_published,
        'badge__lu-submitted-for-publication-status text-warning':
          this.learningUnit.required_review,
        'badge__lu-published-status text-success': this.learningUnit.is_published
      };
    }
  }
};
</script>
